import classNames from "classnames";

function Emoji3({ selected = false, onClick }) {
  return (
    <svg
      width="57"
      height="55"
      viewBox="0 0 57 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="cursor-pointer group"
      onClick={onClick}
    >
      <g clipPath="url(#clip0_16442_1291)">
        <path
          d="M28.6222 46.8646C40.0116 46.8646 49.2445 37.6774 49.2445 26.3444C49.2445 15.0114 40.0116 5.82422 28.6222 5.82422C17.2329 5.82422 8 15.0114 8 26.3444C8 37.6774 17.2329 46.8646 28.6222 46.8646Z"
          className={classNames(
            "group-hover:fill-[#FFCC80]",
            selected ? "fill-[#FFCC80]" : "fill-[#E2E2E2]"
          )}
        />
        <g filter="url(#filter0_d_16442_1291)">
          <path
            d="M28.6222 46.8646C40.0116 46.8646 49.2445 37.6774 49.2445 26.3444C49.2445 15.0114 40.0116 5.82422 28.6222 5.82422C17.2329 5.82422 8 15.0114 8 26.3444C8 37.6774 17.2329 46.8646 28.6222 46.8646Z"
            stroke="white"
            strokeWidth="5"
            strokeMiterlimit="10"
            shapeRendering="crispEdges"
          />
        </g>
        <path
          d="M23.1371 25.1864C24.0906 25.1864 24.8635 23.8177 24.8635 22.1293C24.8635 20.441 24.0906 19.0723 23.1371 19.0723C22.1836 19.0723 21.4106 20.441 21.4106 22.1293C21.4106 23.8177 22.1836 25.1864 23.1371 25.1864Z"
          className={classNames(
            "group-hover:fill-[#1E1E1E]",
            selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
          )}
        />
        <path
          d="M34.1073 25.1864C35.0608 25.1864 35.8338 23.8177 35.8338 22.1293C35.8338 20.441 35.0608 19.0723 34.1073 19.0723C33.1538 19.0723 32.3809 20.441 32.3809 22.1293C32.3809 23.8177 33.1538 25.1864 34.1073 25.1864Z"
          className={classNames(
            "group-hover:fill-[#1E1E1E]",
            selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
          )}
        />
        <path
          d="M22.2739 29.4414C25.3734 34.2705 31.8849 34.2975 34.964 29.4414C34.7261 30.8076 33.9105 32.0994 32.7618 33.0125C29.2409 36.0154 23.1032 34.0135 22.2739 29.4414Z"
          className={classNames(
            "group-hover:fill-[#1E1E1E]",
            selected ? "fill-[#1E1E1E]" : "fill-[#666666]"
          )}
        />
      </g>
      <defs>
        <filter
          id="filter0_d_16442_1291"
          x="1.5"
          y="-0.675781"
          width="54.2446"
          height="54.041"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0 0.650151 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_16442_1291"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_16442_1291"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_16442_1291">
          <rect width="57" height="55" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Emoji3;
